import { render, staticRenderFns } from "./Challenge3.vue?vue&type=template&id=71552068&scoped=true&lang=pug&"
import script from "./Challenge3.vue?vue&type=script&lang=ts&"
export * from "./Challenge3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71552068",
  null
  
)

export default component.exports